<script>
export default {
  name: "TableColumnSearch",
  data() {
    return {
      text : ''
    }
  },
  props : {
    x_button_z_index : {
      type : Number,
      default : 10
    },
    isDisabled : {
      type : Boolean,
      default : false
    },
    inputType : {
      type : String,
      default : 'text',
    }
  },
  methods : {
    sendRequest() {
      this.$emit('callRequestFunction');
    },
    changeValue() {
      this.$emit('input', this.text.trim() === '' ? null : this.text);
    },
    resetValue() {
      this.text = '';
      this.changeValue();
    }
  }
}
</script>

<template>
  <div class="d-flex align-items-center w-auto">
    <div class="input-group position-relative">
      <input
        :type="inputType"
        class="form-control form-control-sm pr-4"
        id="searchInput"
        v-model="text"
        :min="inputType === 'number' ? 0 : null"
        :disabled="isDisabled"
        @input="changeValue"
        @keyup="changeValue"
        @keypress.enter="sendRequest"
        @submit.prevent
      >

      <button
        v-if="text !== ''"
        class="btn btn-link"
        type="button"
        aria-label="Clear"
        @click="resetValue"
        style="top: 50%; transform: translateY(-50%);"
        :disabled="isDisabled"
        :style="{zIndex : x_button_z_index}"
      >
        &times;
      </button>
    </div>

    <font-awesome-icon
      class="ml-2"
      icon="filter"
      style="cursor: pointer;"
      @click="sendRequest"
    />
  </div>

</template>

<style scoped>
.input-group .btn-link {
  padding: 0;
  border: none;
  font-size: 1.25rem;
  color: red;
  text-decoration: none;
  position: absolute;
  right: 5px;
  opacity: 0.6;
}

.input-group .btn-link:hover {
  opacity: 1;
}

</style>
